import type { RouteRecordRaw } from 'vue-router';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    children: [
      {
        path: '',
        name: 'view',
        meta: {
          title: '地图带你游',
          auth: false,
          isApp: false,
        },
        component: () => import('@/views/map/index.vue'),
      },
      {
        path: 'books',
        name: 'BooksMap',
        meta: {
          title: '书店地图',
          auth: false,
          isApp: false,
        },
        component: () => import('@/views/map/books.vue'),
      },
      {
        path: 'routemap',
        name: 'RouteMap',
        meta: {
          title: '路线地图',
          auth: false,
          isApp: false,
        },
        component: () => import('@/views/map/routemap.vue'),
      },
      {
        path: 'tripgroup',
        name: 'Tripgroup',
        meta: {
          title: '路线地图',
          auth: false,
          isApp: false,
        },
        component: () => import('@/views/map/tripgroup.vue'),
      },
      {
        path: 'find',
        name: 'FindMap',
        meta: {
          title: '找X地点',
          auth: false,
          isApp: false,
        },
        component: () => import('@/views/map/find.vue'),
      },
      {
        path: 'advise',
        name: 'Adivse',
        meta: {
          title: '反馈建议',
          auth: false,
          isApp: false,
        },
        component: () => import('@/views/advise.vue'),
      },
      {
        path: 'weather',
        name: 'Weather',
        meta: {
          title: '天气查询',
          auth: false,
          isApp: false,
        },
        component: () => import('@/views/weather/index.vue'),
      },
    ],
  },
];

export default routes;
